import { Component, OnInit, OnDestroy } from '@angular/core';

import { UserService } from './user.service'
import { User } from './user'

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnDestroy, OnInit {

  users: User[];
  connections;
  constructor(private userService: UserService) { }

  getUsers(): void {
    this.connections = this.userService
      .getUsers()
      .subscribe(users => this.users = users);
  }

  ngOnInit(): void {
    this.getUsers()
  }
  ngOnDestroy(): void {
    this.connections.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/users/users.component.ts